import { create } from 'zustand'

// Canal de PDV selecionado na barra superior (feature 09/07 — isolamento por
// canal). Espelha o padrão de lib/filial.ts: store zustand + localStorage, e o
// header X-Canal é injetado em api.ts lendo do localStorage (getCanalHeader).
//
// Valores de visão:
//   'ambos'  → vê os dois canais (padrão de quem tem permissão dos dois / admin)
//   'balcao' → só PDV-Loja
//   'online' → só PDV-Online
//
// O backend IMPÕE os canais permitidos (não confia no header), então este estado
// é só a preferência de visão; um usuário trancado num canal é forçado pelo
// CanalSelector a ficar naquele canal (belt-and-suspenders com a imposição server).
export type CanalView = 'ambos' | 'balcao' | 'online'

const LS_KEY = 'pain_canal_view'

interface CanalState {
  canalView: CanalView
  setCanalView: (v: CanalView) => void
  resetCanal: () => void
}

function getInitial(): CanalView {
  try {
    const v = localStorage.getItem(LS_KEY)
    return v === 'balcao' || v === 'online' ? v : 'ambos'
  } catch { return 'ambos' }
}

export const useCanal = create<CanalState>((set) => ({
  canalView: getInitial(),
  setCanalView: (v) => {
    try { localStorage.setItem(LS_KEY, v) } catch { /* ignore */ }
    set({ canalView: v })
  },
  // Chamado no logout (auth.ts) junto de resetFilial — evita a escolha de canal
  // vazar entre contas na mesma aba (SPA sem reload).
  resetCanal: () => {
    try { localStorage.removeItem(LS_KEY) } catch { /* ignore */ }
    set({ canalView: 'ambos' })
  },
}))

// Lido pelo interceptor do api.ts (que roda fora do React, então lê do
// localStorage e não do hook — igual getFilialIdHeader). Retorna 'balcao'/'online'
// quando a visão é de um canal só; null em 'ambos' (o backend, sem header,
// aplica lockdown se o usuário só pode 1 canal, ou mostra os dois se pode 2).
export function getCanalHeader(): string | null {
  try {
    const v = localStorage.getItem(LS_KEY)
    return v === 'balcao' || v === 'online' ? v : null
  } catch { return null }
}
